/**
 * dcent-x-r3tag.js — R3covery 태깅 데모의 재생·리셋.
 *
 * 마크업은 `snippets/dcent-x-r3tag-demo.liquid`, 화면 변화는 `dcent-x-r3tag.css` 가 갖는다.
 * 여기서 하는 일은 루트에 두 속성을 켜고 끄는 것뿐이다.
 *
 *   data-shown="1"  폰·카드 슬라이드 인 시작 (절반 이상 보일 때)
 *   data-met="1"    도착 후 NFC 리플·타겟 링 표시 (슬라이드 duration 1800ms + 여유 100ms)
 *
 * ── 왜 transitionend 가 아니라 타이머인가 ──────────────────────────────
 * reduced-motion 에서는 트랜지션이 아예 없어 transitionend 가 오지 않는다. 그러면 리플이
 * 영영 안 뜬다 — 모션을 줄인 사용자에게 **정보가 사라지는** 셈이라 타이머로 잡는다(원본과 같은 판단).
 *
 * ── 리셋은 화면 밖에서만 ───────────────────────────────────────────────
 * 절반 이상 보이면 시작하고, **완전히** 벗어났을 때만 처음 상태로 되돌린다. 화면 안에서
 * 되돌리면 카드·폰이 뒤로 밀려나는 모션이 그대로 보인다. 패널이 뷰포트보다 작아 0.5 임계가 안전하다.
 *
 * 안전 규약: 대상 없으면 조용히 종료 · 멱등 설치 · IO 없으면 그냥 켠다.
 *
 * 양 샵 byte-identical — assets/dcent-* 는 parity 게이트 분모다.
 */

if (!window.__dcentXR3Tag) {
  window.__dcentXR3Tag = true;

  /** 슬라이드 duration(1800ms) + 여유. 이 시점에 두 요소가 멈춰 있다. */
  const MEET_AT = 1900;

  const init = () => {
    const roots = document.querySelectorAll("[data-x-r3t]");
    if (!roots.length) return;

    if (!("IntersectionObserver" in window)) {
      roots.forEach((r) => {
        r.dataset.shown = "1";
        window.setTimeout(() => {
          r.dataset.met = "1";
        }, MEET_AT);
      });
      return;
    }

    roots.forEach((root) => {
      if (root.dataset.xR3tReady === "1") return; // 멱등
      root.dataset.xR3tReady = "1";

      let timer = 0;
      const io = new IntersectionObserver(
        ([entry]) => {
          if (entry.intersectionRatio >= 0.5) {
            if (root.dataset.shown === "1") return;
            root.dataset.shown = "1";
            window.clearTimeout(timer);
            timer = window.setTimeout(() => {
              root.dataset.met = "1";
            }, MEET_AT);
          } else if (!entry.isIntersecting) {
            // 완전히 벗어났을 때만 리셋 — 되돌아가는 모션이 보이지 않는다
            window.clearTimeout(timer);
            timer = 0;
            root.dataset.shown = "0";
            root.dataset.met = "0";
          }
        },
        { threshold: [0, 0.5] },
      );
      io.observe(root);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
}
